import { action } from '@ember/object';
import Controller from '@ember/controller';

export default class TagsController extends Controller {
  @action
  noop() {}
}
